/**
 * Faixa que substitui a barra de envio quando o contato está bloqueado
 * (2026-09-01).
 *
 * A ANATOMIA é copiada de `MessagingWindowBlock` (faixa fixa acima do campo de
 * digitar, com botão de ação dentro). As CORES não: aquele componente pinta com
 * hex fixo (`#fffbeb`/`#b45309`/`#f59e0b`), o que viola SEMPRE #4, e o cabeçalho
 * dele admite que a validação nos dois temas nunca foi feita. Aqui tudo sai de
 * variável de tema, e o resultado tem que ser conferido no tema ESCURO.
 * Consertar o componente antigo é outro assunto — não misturar.
 */
interface ContactBlockedBlockProps {
  onUnblock: () => void;
  isUnblocking: boolean;
  /**
   * Quem NÃO tem `contacts:update` continua vendo a faixa (é a explicação de por
   * que a barra de envio sumiu), mas sem o botão: o servidor exige a permissão
   * nas duas rotas, então oferecer o clique só entregaria um erro.
   */
  canUnblock: boolean;
}

export function ContactBlockedBlock({ onUnblock, isUnblocking, canUnblock }: ContactBlockedBlockProps) {
  return (
    <div
      className="flex items-center justify-center gap-2 px-4 py-3.5 text-sm font-medium"
      style={{
        backgroundColor: 'var(--theme-error-subtle)',
        color: 'var(--theme-error-fg)',
      }}
      data-testid="chat-contact-blocked"
    >
      <span>
        Contato bloqueado — as mensagens dele não chegam e nada é enviado a ele.
        {canUnblock && (
          <>
            {' '}
            <button
              type="button"
              onClick={onUnblock}
              disabled={isUnblocking}
              className="underline font-semibold disabled:opacity-60"
              data-testid="chat-contact-unblock"
            >
              Desbloquear
            </button>
          </>
        )}
      </span>
    </div>
  );
}
